import { styled } from 'styled-components';

export const DivLoading = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0px;
`